import {
  SET_USER,
  UPDATE_USER
} from 'constants/ActionTypes'
import { createAction } from 'redux-actions'

export const setUser = createAction(SET_USER, payload => payload)

export const updateUser = createAction(UPDATE_USER, payload => payload)
